import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TableExt, TableInfo, GridBox } from 'libs/ui';
import { getTableParams } from './grid.params';
import { EventInfo } from './blocks/event-info';

export const EventsGrid = (props) => {
  const { count, count_limit, count_method, getFilter, entries, className, theme, getXlsAction } = props;
  const [row, setRow] = useState();
  const { t } = useTranslation();

  /**
   * showinfo
   * @param {*} row
   */
  const showInfo = (row) => {
    setRow(row);
  };

  /**
   * close info
   */
  const closeInfo = () => {
    setRow(null);
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), []);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} count_limit={count_limit} count_method={count_method} getFilter={getFilter} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Системные события')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={showInfo}
        {...tableParams}
      />

      {row && <EventInfo close={closeInfo} row={row} />}
    </GridBox>
  );
};
